package com.milta.core.localization.translations.fr

import com.milta.core.localization.WebHistoriqueStrings

internal val WebHistorique = WebHistoriqueStrings(
    screenATitle = "Historique des tournées",
    periodLabel = "Période",
    periodLastEightDays = "8 derniers jours",
    periodSingleDate = "Date précise",
    periodRange = "Plage de dates",
    rangeFromLabel = "Du",
    rangeToLabel = "Au",
    driverFilterLabel = "Livreur",
    driverFilterAllOption = "Tous les livreurs",
    columnDate = "Date",
    columnDriver = "Livreur",
    columnTotalDeliveries = "Total livraisons",
    columnDelivered = "Livrées",
    columnFailed = "Échecs",
    viewProofsAction = "Voir les preuves",
    emptyHistoryMessage = "Aucune tournée trouvée pour cette période.",
    errorInvalidPeriod = "La période sélectionnée n'est pas valide.",
    screenBTitle = "Historique des preuves de livraison",
    routeOfLabel = "Tournée du",
    totalDeliveriesLabel = "livraisons",
    deliveredLabel = "livrées",
    failedLabel = "échecs",
    backToHistoryAction = "Historique des tournées",
    statusDeliveredBadge = "Livré",
    statusFailedBadge = "Échec",
    viewReasonAction = "Voir le motif",
    hideReasonAction = "Masquer le motif",
    photoPlaceholderAlt = "Aucune photo disponible",
    photoAlt = "Preuve de livraison",
    emptyProofsMessage = "Aucune preuve de livraison disponible pour cette tournée.",
    paginationPrevious = "Précédent",
    paginationNext = "Suivant",
)
